import React from 'react'
import PropTypes from 'prop-types';
const { FormattedText } = require('core/i18n').i18n;

import OKModal from 'components/commons/OKModal/OKModal';

const BrokerConvenienceTestSustainabilityFinishModal = ({isOpen, closeModal, handleFinish}) => {
    const description = <FormattedText value="broker-convenienceMifidTestSustainabilityFinalModal_alternativeFunds_modalContent" /> ;
    return (
        <OKModal
            isOpen={isOpen}
            size="regular"
            headerType="custom"
            title="broker-convenienceMifidTestSustainabilityFinalModal_alternativeFunds_title"
            titleAlignment="center"
            description={description}
            descriptionAlignment="left"
            footerType="navigation"
            primaryButtonText="broker-convenienceMifidTestSustainabilityFinalModal_alternativeFunds_primaryButton"
            onPrimaryButtonClick={handleFinish}
            secondaryButtonText="broker-convenienceMifidTestSustainabilityFinalModal_alternativeFunds_secondaryButton"
            onSecondaryButtonClick={closeModal}
            shouldCloseOnOverlayClick={false}
            onCloseCallback={closeModal}
        />
    );
}

BrokerConvenienceTestSustainabilityFinishModal.propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    handleFinish: PropTypes.func
}

export default BrokerConvenienceTestSustainabilityFinishModal;